var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cblock el--rounded-all el--borders-all"},[_c('div',{staticClass:"cblock__internalpadding"},[_c('div',{staticClass:"loaderblock"},[_vm._m(0),_c('div',{staticClass:"loader-text"},[_vm._v(_vm._s(_vm.$t('LoaderBlock:LoadingText')))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loaderwrap"},[_c('span',{staticClass:"loader2 loader2--dark"})])
}]

export { render, staticRenderFns }